


















import Vue from "vue"
import { Component } from 'vue-property-decorator'
import BaseButton from "@/components/BaseButton.vue"

@Component<OfflineScreen>({
    components: { BaseButton }
})
export default class OfflineScreen extends Vue {

    onClickViewScorecard() {
        this.$router.replace({ name: 'scorecardHome' })
    }

    onClickViewFeedback() {
        this.$router.replace({ name: 'feedback'})
    }
}
